<button *ngIf="options.closeButton" (click)="remove()" class="toast-close-button">
  &times;
</button>
<div *ngIf="title" class="{{options.titleClass}}" [attr.aria-label]="title">
  {{title}}
</div>
<div *ngIf="message && options.enableHtml" class="{{options.messageClass}}" [innerHTML]="message">
</div>
<div *ngIf="message && !options.enableHtml" class="{{options.messageClass}}" [attr.aria-label]="message">
  {{message}}
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width.%]="width"></div>
</div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/alerts/toast/toast.component.html